<app-table
  [columns]="tableColumns"
  [data]="models()"
  [filterFormGroup]="filterFormGroup"
  [loading]="resourceService.loading()"
  (doFilterRequest)="resourceService.getAll($event)"
  (urlParamsChange)="this.urlParams = $event"
  [hasActiveFilters]="resourceService.apiResponse().filters != undefined"
  [pagination]="resourceService.paginationMeta()"
  [deleteLoadingIds]="this.deleteLoadingIds()"
></app-table>
